import { rem } from "@/styles/utils"
import { black, device_px, gray, primary } from "@/styles/variable"
import styled from "styled-components"
import { getMinBreakPoint } from "../../utils/getMinBreakpoint"

const { MAX_767, MAX_1279 } = device_px

export const SessionCardContainer = styled.div`
  height: 236px;
  border-radius: 24px;
  background: ${black[18]};
  padding: 26px;
  cursor: pointer;
  overflow: hidden;
  @media screen and (max-width: ${MAX_767}) {
    min-width: 330px;
    height: 197px;
    padding: 20px 24px;
  }
`
export const SessionCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const SessionCardInner = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 64px);
  gap: 8px;
  @media screen and (max-width: ${MAX_1279}) {
    gap: 4px;
  }
  @media screen and (max-width: ${MAX_767}) {
    gap: 4px;
    height: calc(100% - 48px);
  }
`

export const SessionGroupTagV2 = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  font-size: 14px;
`

export const SessionCardContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
`
export const SessionCardDateTime = styled.div`
  display: block;
`
export const SessionCardDateTimeText = styled.p`
  color: ${gray["aa"]};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  letter-spacing: -0.42px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  word-break: break-all;
  @media screen and (max-width: ${MAX_1279}) {
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 160%;
    letter-spacing: -0.36px;
  }
`

export const SessionCardTitle = styled.div`
  width: 100%;
  @media screen and (max-width: ${MAX_767}) {
    min-width: 300px;
  }
`

export const SessionCardTitleText = styled.p`
  overflow: hidden;
  color: ${primary.white};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.3px;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;

  @media screen and (max-width: ${MAX_1279}) {
    font-size: 14px;
    line-height: 150%;
  }
`

export const SessionCardDesc = styled.div`
  width: 100%;
  flex-grow: 1;
  @media screen and (max-width: ${MAX_767}) {
    min-width: 300px;
  }
`

export const SessionCardDescText = styled.p`
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  color: ${gray[77]};
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.5px;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;

  @media screen and (max-width: ${MAX_767}) {
    -webkit-line-clamp: 3;
    font-size: 12px;
    line-height: 141%;
    letter-spacing: -0.3px;
    font-weight: 500;
  }
`
export const SessionInformation = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  margin-top: auto;
  bottom: 26px;
  position: absolute;
  left: 26px;
  right: 26px;
  height: 48px;

  @media screen and (max-width: ${MAX_767}) {
    bottom: 20px;
    left: 20px;
    right: 20px;
  }
`

export const SessionCardImage = styled.div`
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const SessionCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  color: ${gray[77]};
  gap: 4px;
  font-weight: 500;
  width: calc(100% - 68px);

  p {
    font-size: 14px;
    letter-spacing: -0.3px;
    margin: 0;
    font-weight: 500;

    &:first-child {
      font-size: 18px;
      line-height: 160%;
      color: ${primary.white};
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      width: 100%;
      overflow: hidden;
    }

    &:last-child {
      font-size: 14px;
      line-height: 141%;
      letter-spacing: -0.3px;
      font-weight: 500;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      text-overflow: ellipsis;
      width: 100%;
    }

    @media screen and (max-width: ${MAX_767}) {
      &:first-child {
        font-size: 14px;
        line-height: 165%;
      }
      &:last-child {
        font-size: 12px;
      }
    }
  }
`
export const SessionCardInfoDescription = styled.p`
  width: 230px;
  word-break: break-all;
  @media screen and (max-width: ${MAX_767}) {
    width: 232px;
  }
`

export const SessionCardIconWrapper = styled.div<{
  $isInApp?: boolean
}>`
  --size: ${rem(24)};
  margin-right: ${rem(10)};

  @media (min-width: ${getMinBreakPoint(MAX_767)}) {
    --size: ${rem(24)};
    margin-right: 0;
  }

  & > svg {
    width: 100%;
    height: 100%;
  }
  display: ${props => (props.$isInApp ? "inline-block" : "none")};
  flex-shrink: 0;
  width: var(--size);
  height: var(--size);
`
